import {StoreView} from '@/_application/modules/stores/model/store-view.model';
import {RegionsStores} from '@/framework/static/regions-stores';
import {Region} from '__generated__/__types__';

export const findStoreViewByRegion = async (region: Region) => {
    return RegionsStores.find(store => store.region_id === region.id);
};

export const findStoreViewByRegionCode = (regionCode: string) => {
    return RegionsStores.find(store => store.region_code === regionCode);
};

export const isRegionCodeMatchStoreView = (regionCode: string, currentStoreView: StoreView) => {
    const storeView = findStoreViewByRegionCode(regionCode);
    if (!storeView) {
        return false;
    }
    if (storeView.store_code === currentStoreView.store_code) {
        return true;
    }
    return false;
};
